import React from 'react';
import styled from 'styled-components/macro';
import NavItem from './NavItem';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  background-color: #5d7a8c;
  box-shadow: 0 0px 24px 0 rgba(0, 0, 0, 0.38);
  border-top: 4px solid #a78a38;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 60px;
  box-sizing: border-box;
  z-index: 100;

  @media screen and (max-width: 700px) {
    justify-content: flex-start;
  }

  @media screen and (max-width: 800px) {
    height: auto;
    padding: 0 30px;
  }
`;

const Navbar = () => {
  return (
    <Wrapper>
      <NavItem to="/firm">Firm</NavItem>
      <NavItem to="/services">Services</NavItem>
      <NavItem to="/clients">Clients</NavItem>
      <NavItem to="/team">Team</NavItem>
      {/* <NavItem to="/testimonials">Testimonials</NavItem> */}
      {/* <NavItem to="/news">News</NavItem> */}
      <NavItem to="/contact">Contact</NavItem>
    </Wrapper>
  );
};

export default Navbar;
